// eslint-disable-next-line import/no-anonymous-default-export
export default (asset = [], action) => {
  switch (action.type) {
    case "FETCH_ALL_ASSET":
      return action.payload;

    case "CREATE_ASSET":
      return [...asset, action.payload];

    default:
      return asset;
  }
};
